import * as ConfigCat from 'configcat-react'
import {useAuth} from '../stores/AuthStore'

export const useFeatureFlag = <T extends ConfigCat.SettingValue>(
  key: string,
  defaultValue: T,
): {
  value: ConfigCat.SettingTypeOf<T>
  loading: boolean
} => {
  const {client, person} = useAuth()

  let configCatUser

  if (client?.ID && person?.ID) {
    configCatUser = new ConfigCat.User(
      person.ID,
      person.email ?? undefined,
      '',
      {
        clientId: client.ID,
        clientName: client.name,
        application: 'Campanion Admin',
      },
    )
  }

  return ConfigCat.useFeatureFlag(key, defaultValue, configCatUser)
}
